export class JRpcSuccResponse<T> {
    public jsonrpc: '2.0';
    public result: T;

    constructor(result: T) {
        this.result = result;
    }
}
